(function() {
  'use strict';

  function Cards($translate, Sidebar) {
    var service = {};

    service.register = function() {
      var cards = [
        {
          id: 'events-bookmark',
          title: $translate.instant('Bookmarked searches'),
          directive: 'sidebar-bookmark',
          options: {
            routes: [
              'epf'
            ]
          },
          order: 1
        },
        {
          id: 'help',
          title: $translate.instant('Information'),
          directive: 'sidebar-help',
          options: {
            routes: ['epf']
          },
          order: 2000
        },
        {
          id: 'form-errors',
          title: $translate.instant('Form errors'),
          directive: 'sidebar-form-errors',
          type: 'danger',
          options: {
            routes: ['epf']
          }
        }
      ];

      Sidebar.registerCards(cards);
    };

    return service;
  }

  Cards.$inject = ['$translate', 'SidebarService'];

  angular.module('layout.sidebar')
    .service('GeneralCards', Cards);
})();
